<template>
    <div id="upgrade-plan-container">
        <div v-if="account.plan_id < 2 || account.plan_id > 5" style="width: 100%; gap: 15px;"
             class="d-flex align-center justify-space-between"
        >
            <span style="color: #fff; font-size: 12px; font-weight: bold">Plan: {{
					isCurrentPlanFree ? 'fylm.ai Lite (Free)' : 'fylm.ai Lite'
                }}</span>
            <v-btn @click="upgradePlan"
                   class="rounded-xl my-auto upgrade-plan-btn"
                   small
                   outlined
                   color="white"
            >
                Upgrade plan
            </v-btn>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    computed: {
        ...mapState("User", ["account"]),
        ...mapGetters('User', ['isCurrentPlanFree']),
    },

    methods: {
        upgradePlan() {
            this.$router.push({name: "account.billing.changePlan"});
        },
    }
}
</script>

<style lang="scss" scoped>
#upgrade-plan-container {
    display: flex;
    align-items: center;
    justify-content: stretch;
    z-index: 10;
}
</style>